module.exports = __webpack_public_path__ + "img/scoring.de12a9be.png";